/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Categories_UpdatedInputs */

const en_admin_categories_updated = /** @type {(inputs: Admin_Categories_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Category updated`)
};

const zh_admin_categories_updated = /** @type {(inputs: Admin_Categories_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分类已更新`)
};

/**
* | output |
* | --- |
* | "Category updated" |
*
* @param {Admin_Categories_UpdatedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_categories_updated = /** @type {((inputs?: Admin_Categories_UpdatedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Categories_UpdatedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_categories_updated(inputs)
	return zh_admin_categories_updated(inputs)
});
export { admin_categories_updated as "admin.categories.updated" }